import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getPABillingInfoSlice = createSlice({
  name: "getPABillingInfo",
  initialState,
  reducers: {
    getPABillingInfoStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getPABillingInfoSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getPABillingInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getPABillingInfoStart,
  getPABillingInfoSuccess,
  getPABillingInfoFailure,
  clearError,
  clearMessage,
} = getPABillingInfoSlice.actions;

export default getPABillingInfoSlice.reducer;
